class AdditionalDataUsersController {
  static controller($scope, $state, PHONE_REGEX) {
    'ngInject';

    $scope.phoneRegex = PHONE_REGEX;

    $scope.additionalData = function (additionalDataForm) {
      alert("Tu nastąpi przejście do systemu");
    }
  };
}

export default AdditionalDataUsersController.controller;



// WEBPACK FOOTER //
// ./src/users/additional-data.users.controller.js